import { IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'
import { IoChevronDownOutline } from "react-icons/io5";


export default function TemplateHeaderOptionsButton({ 
  handleCreateDsrWithTemplate,
}) {

  return (
    <>

      <Menu isLazy placement="bottom-end" bg='gray.500'>
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<IoChevronDownOutline />}
          // variant='outline'
          size='2em'
          p='0.5em'
          rounded='50%'
        />
        <MenuList px='0.5em' fontSize='0.875em'>
          <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => handleCreateDsrWithTemplate()}  >Create Room with this template</MenuItem>
        </MenuList>
      </Menu>

    </>
  );
}